var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24738_535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.59375,
    y: 0.366699,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24738_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44375 17.4667C7.29375 16.8167 8.24375 16.3042 9.29375 15.9292C10.3438 15.5542 11.4438 15.3667 12.5938 15.3667C13.7437 15.3667 14.8438 15.5542 15.8938 15.9292C16.9438 16.3042 17.8937 16.8167 18.7437 17.4667C19.3271 16.7834 19.7813 16.0084 20.1063 15.1417C20.4313 14.275 20.5938 13.35 20.5938 12.3667C20.5938 10.15 19.8146 8.26253 18.2563 6.7042C16.6979 5.14587 14.8104 4.3667 12.5938 4.3667C10.3771 4.3667 8.48958 5.14587 6.93125 6.7042C5.37292 8.26253 4.59375 10.15 4.59375 12.3667C4.59375 13.35 4.75625 14.275 5.08125 15.1417C5.40625 16.0084 5.86042 16.7834 6.44375 17.4667ZM12.5938 13.3667C11.6104 13.3667 10.7813 13.0292 10.1063 12.3542C9.43125 11.6792 9.09375 10.85 9.09375 9.8667C9.09375 8.88337 9.43125 8.0542 10.1063 7.3792C10.7813 6.7042 11.6104 6.3667 12.5938 6.3667C13.5771 6.3667 14.4063 6.7042 15.0813 7.3792C15.7563 8.0542 16.0938 8.88337 16.0938 9.8667C16.0938 10.85 15.7563 11.6792 15.0813 12.3542C14.4063 13.0292 13.5771 13.3667 12.5938 13.3667ZM12.5938 22.3667C11.2104 22.3667 9.91042 22.1042 8.69375 21.5792C7.47708 21.0542 6.41875 20.3417 5.51875 19.4417C4.61875 18.5417 3.90625 17.4834 3.38125 16.2667C2.85625 15.05 2.59375 13.75 2.59375 12.3667C2.59375 10.9834 2.85625 9.68337 3.38125 8.4667C3.90625 7.25003 4.61875 6.1917 5.51875 5.2917C6.41875 4.3917 7.47708 3.6792 8.69375 3.1542C9.91042 2.6292 11.2104 2.3667 12.5938 2.3667C13.9771 2.3667 15.2771 2.6292 16.4938 3.1542C17.7104 3.6792 18.7688 4.3917 19.6688 5.2917C20.5688 6.1917 21.2812 7.25003 21.8062 8.4667C22.3312 9.68337 22.5938 10.9834 22.5938 12.3667C22.5938 13.75 22.3312 15.05 21.8062 16.2667C21.2812 17.4834 20.5688 18.5417 19.6688 19.4417C18.7688 20.3417 17.7104 21.0542 16.4938 21.5792C15.2771 22.1042 13.9771 22.3667 12.5938 22.3667Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9e1f7c93836fa8d39d4d515084ef2ace.svg";
export { ForwardRef as ReactComponent };